import { isDevMode, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CrmEndpointModule } from 'common-module/endpoint';
import { CrmAuthRouteGuard } from 'common-module/auth';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { CrmMessageModule } from 'common-module/message';
import { endpointModuleConfiguration } from '@environments/environment';
import { CrmDefaultPaginationToken, CrmPagination } from 'common-module/table';
import { CrmVersionModule } from 'common-module/version';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NewVersionComponent } from '@app/shared/components/new-version/new-version.component';
import { SignatureService } from '@app/pages/pl-cards/signature.service';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import sk from '@angular/common/locales/sk';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from './core/crm/layout/layout.module';
import { ConfigurationModule } from './core/crm/configuration/configuration.module';
import { TranslateModule } from './core/crm/translate/translate.module';

registerLocaleData(sk);
registerLocaleData(en);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    // Crm overrides
    LayoutModule,
    ConfigurationModule,
    TranslateModule,
    CrmEndpointModule.forRoot(endpointModuleConfiguration),
    NzModalModule,
    CrmMessageModule,

    // Service worker setup
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    CrmVersionModule.forRoot({
      enabled: !isDevMode(),
      versionPollingInterval: 5000,
    }),
    NewVersionComponent,
  ],
  providers: [
    CrmAuthRouteGuard,
    {
      provide: CrmDefaultPaginationToken,
      useValue: {
        skip: 0,
        limit: 50,
      } satisfies CrmPagination,
    },
    { provide: NZ_I18N, useValue: en_US },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    SignatureService.initPdfWorker();
  }
}
